export default __webpack_public_path__ + "static/media/avatar10.0ff30d92.png";